import React from 'react'
import { cn } from 'lib/utils'
import type { IReaction } from 'features/Chat/Chat.types'

/** Reactions arrive with `userId` either populated or as a bare id. */
export const reactorId = (reaction: any) => String(reaction?.userId?._id || reaction?.userId || '')

/** The current user's reaction on a message, if any. */
export const myReactionOf = (reactions: IReaction[] = [], userId?: string) =>
	reactions.find(r => reactorId(r) === String(userId))?.emoji

export interface Props {
	reactions?: IReaction[]
	userId?: string
	onToggle?: (emoji: string) => void
	className?: string
}

/**
 * The chip of reactions under a message. Clicking your own clears it; clicking
 * someone else's adds that same reaction as yours.
 */
const MessageReactions = ({ reactions = [], userId, onToggle, className = '' }: Props) => {
	if (reactions.length === 0) return null

	return (
		<span
			className={cn(
				'inline-flex items-center gap-0.5 rounded-full border border-gray-200 bg-white px-1.5 py-0.5 text-[12px] shadow-sm',
				className,
			)}
		>
			{reactions.map((r, i) => (
				<button
					key={`${reactorId(r)}-${i}`}
					type="button"
					onClick={() => onToggle?.(r.emoji)}
					aria-label={
						reactorId(r) === String(userId) ? `Remove your ${r.emoji}` : `React with ${r.emoji}`
					}
					className="leading-none transition-transform hover:scale-125"
				>
					{r.emoji}
				</button>
			))}
		</span>
	)
}

export default MessageReactions
